/* eslint-disable @typescript-eslint/no-unused-vars */
import { pluralizeWord } from '@doveit/hammer';
import {
  GoalMetric, PerformanceMetric, PerformanceRating, TimeRange,
} from '../../../../providers/api/dtos';
import { template } from '../../../../utils/text/text';

export const configByMetric: Record<GoalMetric, {
  label: {
    stem: string
    singular: string,
    plural: string,
  },
  frequency: string,
  verb: string
}> = {
  rumors: {
    label: {
      stem: 'notizi',
      singular: 'a',
      plural: 'e',
    },
    frequency: 'a settimana',
    verb: 'inserire',
  },
  prospects: {
    label: {
      stem: 'valutazion',
      singular: 'e',
      plural: 'i',
    },
    frequency: 'a settimana',
    verb: 'effettuare',
  },
  assignments: {
    label: {
      stem: 'mandat',
      singular: 'o',
      plural: 'i',
    },
    frequency: 'al mese',
    verb: 'acquisire',
  },
  sales: {
    label: {
      stem: 'vendit',
      singular: 'a',
      plural: 'e',
    },
    frequency: 'al mese',
    verb: 'concludere',
  },
};

const performanceDescriptionTemplate: Record<PerformanceRating, string> = {
  CRITICAL: 'Ad oggi avrebbe dovuto {METRIC_VERB} {EXPECTED} {EXPECTED_METRIC_LABEL}, è in ritardo di {DELTA}.  \nLa media è di **{AVERAGE} {EXPECTED_METRIC_LABEL} {METRIC_FREQUENCY}**, ben al di sotto della **media richiesta di {EXPECTED_AVERAGE}**.',
  BELOW_EXPECTATIONS: 'Ad oggi avrebbe dovuto {METRIC_VERB} {EXPECTED} {EXPECTED_METRIC_LABEL}, è in ritardo di {DELTA}.  \nLa media è di **{AVERAGE} {EXPECTED_METRIC_LABEL} {METRIC_FREQUENCY}**, sotto la **media richiesta di {EXPECTED_AVERAGE}**.',
  NEARLY_ON_TRACK: 'Ad oggi avrebbe dovuto {METRIC_VERB} {EXPECTED} {EXPECTED_METRIC_LABEL}, è leggermente in ritardo di {DELTA}.  \nLa media è di **{AVERAGE} {EXPECTED_METRIC_LABEL} {METRIC_FREQUENCY}**, a fronte di una **media richiesta di {EXPECTED_AVERAGE}**.',
  ON_TRACK: 'Ad oggi avrebbe dovuto {METRIC_VERB} {EXPECTED} {EXPECTED_METRIC_LABEL}, è in anticipo di {DELTA}.  \nLa media è di **{AVERAGE} {EXPECTED_METRIC_LABEL} {METRIC_FREQUENCY}**, a fronte di una **media richiesta di {EXPECTED_AVERAGE}**.',
  ABOVE_EXPECTATIONS: 'Ad oggi avrebbe dovuto {METRIC_VERB} {EXPECTED} {EXPECTED_METRIC_LABEL}, è in anticipo di {DELTA}.  \nLa media è di **{AVERAGE} {EXPECTED_METRIC_LABEL} {METRIC_FREQUENCY}**, a fronte di una **media richiesta di {EXPECTED_AVERAGE}**.',
};

export function getPerformanceDescription(
  {
    metric,
    metricData,
    timeRange,
  }: {
    metric: GoalMetric,
    metricData: Record<TimeRange, PerformanceMetric>,
    timeRange: TimeRange
  },
) {
  const { label: { stem, singular, plural }, verb, frequency } = configByMetric[metric];

  const { status } = metricData.yearly;
  const metricYearlyExpected = metricData.yearly.expected;
  const metricYearlyDelta = metricData.yearly.delta;
  const metricPerformance = metricData[timeRange].performance;
  const metricExpected = metricData[timeRange].expected;

  const templateString = performanceDescriptionTemplate[status];

  return template(templateString, {
    EXPECTED: metricYearlyExpected,
    METRIC_VERB: verb,
    EXPECTED_METRIC_LABEL: pluralizeWord(stem, singular, plural, metricYearlyExpected),
    METRIC_FREQUENCY: frequency,
    DELTA: Math.abs(metricYearlyDelta),
    AVERAGE: metricPerformance,
    EXPECTED_AVERAGE: metricExpected,
  });
}
